import { getUserState } from '@carvana/core-auth';

// FIXME - to review for iOS native app. This value can only be fetched on Web.
export const getUserIdFromAuthCookie = (): string | null => {
  const { user } = getUserState();
  const { user_id } = user;
  return user_id;
};
